module.exports = __webpack_public_path__ + "static/media/fera.75557889.png";